import { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import useTheme from 'api/useTheme';
import { decodeRichTextContent } from 'utils/colorUtils';
import { isRichTextEmpty } from 'utils/richTextUtils';

import { defaultGeneralTheme } from './defaults';
import { GeneralThemeFormValues } from './generalTheme.types';

export const useGetGeneralInitialValues = () => {
  const location = useLocation();
  const { publisherId } = useParams();

  const [initialValues, setInitialValue] =
    useState<GeneralThemeFormValues>(defaultGeneralTheme);
  const { getGeneralTheme: generalTheme } = useTheme(publisherId);

  useEffect(() => {
    setInitialValue({
      storeTabName:
        generalTheme.data?.storeTabName || defaultGeneralTheme.storeTabName,
      logo: generalTheme.data?.logo || defaultGeneralTheme.logo,
      favicon: generalTheme.data?.favicon || defaultGeneralTheme.favicon,
      backgroundImageMobile:
        generalTheme.data?.backgroundImageMobile ||
        defaultGeneralTheme.backgroundImageMobile,
      backgroundImageDesktop:
        generalTheme.data?.backgroundImageDesktop ||
        defaultGeneralTheme.backgroundImageDesktop,
      storeSaleImage:
        generalTheme.data?.storeSaleImage || defaultGeneralTheme.storeSaleImage,
      loaderAnimation:
        generalTheme.data?.loaderAnimation ||
        defaultGeneralTheme.loaderAnimation,
      font: generalTheme.data?.font || defaultGeneralTheme.font,
      receiptHeader:
        generalTheme.data?.receiptHeader || defaultGeneralTheme.receiptHeader,
      footer: {
        imageMobile:
          generalTheme.data?.footer?.imageMobile ||
          defaultGeneralTheme.footer.imageMobile,
        imageDesktop:
          generalTheme.data?.footer?.imageDesktop ||
          defaultGeneralTheme.footer.imageDesktop,
        appstoreLink:
          generalTheme.data?.footer?.appstoreLink ||
          defaultGeneralTheme.footer.appstoreLink,
        googlePlayLink:
          generalTheme.data?.footer?.googlePlayLink ||
          defaultGeneralTheme.footer.googlePlayLink,
        privacyPolicyUrl:
          generalTheme.data?.footer?.privacyPolicyUrl ||
          defaultGeneralTheme.footer.privacyPolicyUrl,
        termsAndConditionsUrl:
          generalTheme.data?.footer?.termsAndConditionsUrl ||
          defaultGeneralTheme.footer.termsAndConditionsUrl,
        supportLink:
          generalTheme.data?.footer?.supportLink ||
          defaultGeneralTheme.footer.supportLink,
        supportParams: {
          playerIdParamName:
            generalTheme.data?.footer?.supportParams?.playerIdParamName ||
            defaultGeneralTheme.footer.supportParams?.playerIdParamName,
          playerNameParamName:
            generalTheme.data?.footer?.supportParams?.playerNameParamName ||
            defaultGeneralTheme.footer.supportParams?.playerNameParamName
        },
        openLinksInNewTab:
          generalTheme.data?.footer?.openLinksInNewTab ||
          defaultGeneralTheme?.footer.openLinksInNewTab,
        showCookieSettings:
          generalTheme.data?.footer?.showCookieSettings ||
          defaultGeneralTheme?.footer.showCookieSettings
      },
      maintenanceModeRichText: (() => {
        const source = generalTheme.data?.maintenanceModeRichText;
        const { text: decoded, fontColor } = decodeRichTextContent(source);
        const defaultText =
          defaultGeneralTheme.maintenanceModeRichText?.text ?? '';
        const text =
          !decoded || isRichTextEmpty(decoded) ? defaultText : decoded;
        return {
          text,
          fontColor:
            fontColor ??
            defaultGeneralTheme.maintenanceModeRichText?.fontColor ??
            'rgb(0, 0, 0)'
        };
      })()
    });
  }, [generalTheme.data, location]);

  return { initialValues };
};
